export function nodeConsoleTarget(search = window.location.search) {
  const cluster = new URLSearchParams(search).get('cluster');
  return { url: '/api/orch/k8s/console' + (cluster && /^[a-z0-9-]{1,40}$/.test(cluster) ? '?cluster=' + cluster : ''), embedded: true };
}
